import { ApplicantStatus } from '@/Models/CandidateOverview';

function isDownloadCVAllowed(applicantStatus: ApplicantStatus) {
    // When applicant applies we require CV upload. Therefore, the only time when CV is not available is
    // when applicant is in invited status.
    return applicantStatus !== ApplicantStatus.Invited;
}

export default isDownloadCVAllowed;
